<style lang="scss" scoped>
  @import "../../../../assets/scss/mixins";


  $leftWidth: 220px;

  .el-form .el-checkbox__label {
    font-size: 12px;
    padding-left: 5px;
  }

  .el-form .el-checkbox__inner {
    width: 14px;
    height: 14px;
  }

  .content-part {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;

    .content-left {
      width: $leftWidth;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      text-align: left;
      background-color: #eef2f3;

      > ul {
        margin: 0;
      }

      > h2 {
        padding: 0;
        margin: 0;
        font-size: 18px;
        font-weight: bold;
        line-height: 55px;
        border-bottom: 1px solid #ddd;
        background-color: #eef2f3;
      }

      .list-style {
        cursor: pointer;
        padding: 10px;
        text-align: center;

        span {
          display: inline-block;
          padding: 8px 35px;
        }

        &.active {
          span {
            background-color: $activeColor;
            border-radius: 20px;
            color: $activeColorFont
          }
        }

        &:hover {
          background: #dee9eb
        }

      }

    }

    .content-right {
      > h3 {
        padding: 0;
        margin: 0 0 20px;
        font-size: 18px;
        font-weight: normal;
        line-height: 55px;
        height: 55px;
        border-bottom: 1px solid #ddd;
        text-align: center;
        position: fixed;
        top: 0;
        right: 0;
        left: $leftWidth;
        background: #fff;
        z-index: 2;
      }

      position: absolute;
      top: 0;
      left: $leftWidth;
      right: 0;
      bottom: 0;
      overflow: auto;
      /*.hide-content {*/
      /*display: none;*/
      /*}*/
      /*.show-content {*/
      /*display: block;*/
      /*}*/
    }

    .min-gutter {
      .el-form-item {
        margin-bottom: 0px;

        .el-form-item__content {
          line-height: 20px;
          position: relative;
          font-size: 14px;
        }

        .el-form-item__label {
          text-align: right;
          vertical-align: middle;
          float: left;
          font-size: 14px;
          color: #606266;
          line-height: 20px;
          padding: 0 12px 0 0;
          box-sizing: border-box;
        }

      }

      .el-form-item__label {
        font-size: 12px
      }
    }

    .qp-box {
      margin-bottom: 5px;
      padding: 4px;
      box-shadow: 0 2px 1px 0 #ddd;
    }
  }

  .el-form .el-select {
    display: block;
  }

  .el-form .el-date-editor {
    display: block;
  }

  .el-form {
    border: 1px solid #eef2f3;
    margin: 15px 10px;
    border-radius: 4px;
    position: relative;
    padding-top: 10px;

    &.active {
      border-color: $activeColor;

      .title-link {
        color: $activeColor;
      }
    }
  }

  .title-link {
    position: absolute;
    top: -10px;
    left: 5px;
    padding: 0;
  }

  .btn-submit-save {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    text-align: center;
    padding: 15px;
  }

</style>
<style lang="scss">
  .goods-form-info {
    .item-line-height {
      .el-form-item__label {
        line-height: 40px;
      }
    }
  }
</style>

<template>
  <div>
    <div class="content-part">
      <div class="content-left">
        <h2 class="clearfix right-title">合并</h2>
        <ul>
          <div class="btn-submit-save">
            <div>
              <el-button type="primary" style="width: 180px" @click.prevent.stop="mergeGoods()"
                         :disabled="doing" :loading="doing">{{title}}
              </el-button>
            </div>
          </div>
        </ul>
      </div>
      <div class="content-right min-gutter">
        <el-form id="0" class="form-part goods-form-info" :class="{active: index === 0}" ref="baseForm"
                 label-width="160px"
                 style="padding-right: 20px;margin-top:65px">
          <h2 class="title-link">货品主档</h2>
          <div class="hide-content">
            <el-form-item label="货品名称:">
              {{form.name}}
            </el-form-item>
            <el-form-item label="货品id:">
              {{form.id}}
            </el-form-item>
            <el-form-item label="货品编号:">
              {{form.code}}
            </el-form-item>
            <el-form-item label="货品分类:">
              <dict :dict-group="'typeId'" :dict-key="form.typeId"></dict>
            </el-form-item>
            <el-form-item label="规格/型号:">
              {{form.specifications}}
            </el-form-item>
            <el-form-item label="生产厂商:">
              {{form.factoryName}}
            </el-form-item>
          </div>
        </el-form>
        <el-form id="1" class="form-part goods-form-info" :class="{active: index === 1}" ref="storeForm"
                 label-width="160px" style="padding-right: 20px;margin-top:25px">
          <h2 class="title-link">待合并货品信息</h2>
          <div class="hide-content">
            <el-form-item label="货品" v-if="form.id" style="margin-bottom: 5px" class="item-line-height">
              <el-select placeholder="请输入名称搜索货品" v-model="mergeGoodsId" filterable remote
                         :remote-method="filterDhsGoods"
                         :clearable="true" popperClass="good-selects" @click.native="filterDhsGoods('')"
                         @change="setDhsGoods()">
                <el-option :label="item.name" :value="item.id" :key="item.id" v-for="item in dhsGoodList">
                  <div>
                    <span class="pull-left">{{ item.name }}({{ item.factoryName }})</span>
                    <span class="pull-right" style="color:#999">
              <dict :dict-group="'typeId'" :dict-key="item.typeId"></dict>
            </span>
                  </div>
                  <div class="clearfix">
                    <span class="pull-left" style="color:#999" v-if="item.code ">货品编号 {{ item.code }}</span>
                    <span class="pull-left" style="color:#999" v-if="item.id ">货品ID {{ item.id }}</span>
                    <span class="pull-right" style="color:#999">规格 {{ item.specifications }}</span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="货品id:" v-if="dhsGoods.id">
              {{dhsGoods.id}}
            </el-form-item>
            <el-form-item label="货品编号:" v-if="dhsGoods.id">
              {{dhsGoods.code}}
            </el-form-item>
            <el-form-item label="货品分类:" v-if="dhsGoods.id">
              <dict :dict-group="'typeId'" :dict-key="dhsGoods.typeId"></dict>
            </el-form-item>
            <el-form-item label="规格/型号:" v-if="dhsGoods.id">
              {{dhsGoods.specifications}}
            </el-form-item>
            <el-form-item label="生产厂商:" style="padding-bottom: 5px" v-if="dhsGoods.id">
              {{dhsGoods.factoryName}}
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import {Goods} from '../../../../resources';

  export default {
    components: {},
    name: 'mergeForm',
    props: {
      formItem: {
        type: Object,
        default: {},
        required: true
      }
    },
    data: function () {
      return {
        index: 0,
        doing: false,
        title: '合并货品',
        form: {},
        span: 8,
        dhsGoodList: [],
        dhsGoods: {},
        mergeGoodsId: ''
      };
    },
    computed: {},
    watch: {
      formItem(val) {
        if (val) {
          this.form = JSON.parse(JSON.stringify(val));
          this.dhsGoodList = [];
          this.dhsGoods = [];
          this.mergeGoodsId = '';
        }
      }
    },
    mounted: function () {
    },
    methods: {
      mergeGoods: function () {
        if (!this.mergeGoodsId) {
          this.$notify.warning({
            duration: 2000,
            name: '成功',
            message: '请选择待合并货品信息后再进行合并货品的操作'
          });
          return;
        }
        this.$confirm('确认将货品"' + this.form.name + '"和货品"' + this.dhsGoods.name + '"进行合并?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.doing = true;
          let itemTemp = JSON.parse(JSON.stringify(this.form));
          let params = {
            masterDhsGoodsId: itemTemp.id,
            followDhsGoodsId: this.dhsGoods.id
          };
          Goods.mergeGoodsInfo(itemTemp.id, params).then(() => {
            this.doing = false;
            this.$notify.success({
              title: '成功',
              message: '货品"' + this.form.name + '"和货品"' + this.dhsGoods.name + '"合并成功'
            });
            this.$emit('change', this.form);
            this.$emit('right-close');
          }).catch(error => {
            this.doing = false;
            this.$notify.error({
              duration: 2000,
              message: error.response.data && error.response.data.msg || '货品"' + this.form.name + '"和货品"' + this.dhsGoods.name + '"合并失败'
            });
          });
        });
      },
      filterDhsGoods(query) {
        let param = Object.assign({}, {
          pageNo: 1,
          pageSize: 20,
          deleteFlag: false,
          keyWord: query
        });
        Goods.query(param).then(res => {
          if (res.data.list.length > 0) {
            this.dhsGoodList = res.data.list;
          } else {
            this.dhsGoodList = [];
          }
        });
      },
      setDhsGoods: function () {
        if (!this.mergeGoodsId) return;
        if (this.mergeGoodsId === this.form.id) {
          this.$notify.warning({
            duration: 2000,
            name: '成功',
            message: '请选择和货品:' + this.form.name + ' 不同的货品进行合并操作'
          });
          this.mergeGoodsId = '';
          return;
        }
        this.dhsGoodList.forEach(goods => {
          if (this.mergeGoodsId === goods.id) {
            this.dhsGoods = goods;
          }
        });
      }
    }
  };
</script>
